export const VAD_THRESHOLD_MAX = 0.98;
export const WAITING_TIME_MAX = 5000;
export const WAITING_TIME_WARNING_THRESHOLD = 2000;
